(() => {
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  const tagDetails = (tag) => {
    const normalized = String(tag).toLowerCase();
    if (normalized.includes('immergrün')) return { title: tag, description: 'Ganzjährig dichter Sichtschutz' };
    if (normalized.includes('sommergrün')) return { title: tag, description: 'Lebendiger Austrieb im Frühjahr' };
    if (normalized.includes('winter')) return { title: tag, description: 'Robust und widerstandsfähig' };
    if (normalized.includes('sicht')) return { title: tag, description: 'Schützt zuverlässig vor Blicken' };
    if (normalized.includes('essbar')) return { title: tag, description: 'Genuss direkt aus dem Garten' };
    if (normalized.includes('blüte') || normalized.includes('blüh')) return { title: tag, description: 'Attraktive saisonale Blüte' };
    if (normalized.includes('panasch')) return { title: tag, description: 'Markante mehrfarbige Blätter' };
    if (normalized.includes('laub')) return { title: tag, description: 'Dekorative, charaktervolle Belaubung' };
    return { title: tag, description: 'Ausgewähltes Pflanzenmerkmal' };
  };

  const iconFor = (tag) => {
    const normalized = String(tag).toLowerCase();
    if (normalized.includes('winter')) return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2v20M4.9 6l14.2 12M19.1 6 4.9 18M8 3l4 3 4-3M8 21l4-3 4 3M3 9l4 3-4 3M21 9l-4 3 4 3"/></svg>';
    if (normalized.includes('sicht')) return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4 6v5c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6l-8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></svg>';
    if (normalized.includes('blüh')) return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="2"/><path d="M12 10c-2-5 3-7 4-3 4-1 5 4 1 5 3 4-1 7-4 4-2 5-7 2-4-2-5 0-7-5-3-6Z"/></svg>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4C12 4 5 8 5 15c0 2 1 4 3 5 1-6 5-10 11-13-5 4-8 8-9 13 7 0 11-5 10-16Z"/></svg>';
  };

  document.querySelectorAll('.hx[data-section-id]').forEach((root) => {
    if (root.dataset.hxInitialized === 'true') return;
    root.dataset.hxInitialized = 'true';

    const configNode = root.querySelector('[data-hx-config]');
    if (!configNode) return;

    let config;
    try { config = JSON.parse(configNode.textContent); }
    catch (error) { console.error('Helix Konfigurator: ungültige Konfiguration', error); return; }

    const q = (selector) => root.querySelector(selector);
    const qa = (selector) => [...root.querySelectorAll(selector)];
    const currency = new Intl.NumberFormat('de-DE', { style: 'currency', currency: config.currency || 'EUR' });
    const PLANNING_GRID = 1.3;
    const shapes = {
      straight: { label: config.labels.straight, segments: 1, corners: 0 },
      l: { label: config.labels.l, segments: 2, corners: 1 },
      u: { label: config.labels.u, segments: 3, corners: 2 }
    };

    const legacyVariantIds = {
      '15898210173277': '63304011678045',
      '14754263990621': '54817849508189',
      '15898210238813': '63304011907421',
      '15898210271581': '63304011972957',
      '8803894985053': '49390912536925',
      '14753582842205': '54814632083805',
      '14754144977245': '54817473757533'
    };
    const catalog = {};
    (config.products || []).forEach((item) => {
      if (!item.group || !item.height || !item.variantId) return;
      const configuredVariantId = String(item.variantId);
      const currentVariantId = legacyVariantIds[configuredVariantId] || configuredVariantId;
      if (!catalog[item.group]) {
        catalog[item.group] = {
          family: item.family || 'evergreen', title: item.title, botanical: item.botanical,
          subtitle: item.subtitle, image: item.image, tags: item.tags || [], sortOrder: item.sortOrder, variants: {}
        };
      }
      catalog[item.group].variants[item.height] = {
        price: Number(item.price) || 0, variantId: Number(currentVariantId), article: item.article || '',
        image: item.image || catalog[item.group].image, available: item.available !== false
      };
    });

    const defaultHeight = Number(q('[data-summary-height]')?.textContent.replace(/\D/g, '')) || 180;
    const state = {
      step: 1, height: defaultHeight, shape: 'straight',
      selectedProducts: [], activeBrush: null, assignments: [], chooserOpen: false,
      expandedHeightChoices: {},
      customHeightMode: false,
      customHeightPlans: [[], [], []],
      interruptions: [
        { enabled: false, width: 1, position: 1.3 },
        { enabled: false, width: 1, position: 1.3 },
        { enabled: false, width: 1, position: 1.3 }
      ],
      heightChanges: [
        { enabled: false, height: 205, position: 1.3 },
        { enabled: false, height: 205, position: 1.3 },
        { enabled: false, height: 205, position: 1.3 }
      ],
      interruptionMode: false,
      // Immer mit genau einem Planungsraster starten. So überschreiben auch
      // gespeicherte Section-Werte älterer Theme-Versionen (z. B. 7,80 m)
      // nicht mehr die gewünschte Voreinstellung.
      lengths: [1.3, 1.3, 1.3]
    };
    const STORAGE_KEY = `helix-configurator:${config.sectionId}`;
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (stored && typeof stored === 'object') {
        state.step = Math.min(5, Math.max(1, Number(stored.step) || 1));
        state.height = [100, 180, 205].includes(Number(stored.height)) ? Number(stored.height) : state.height;
        state.shape = shapes[stored.shape] ? stored.shape : state.shape;
        state.selectedProducts = Array.isArray(stored.selectedProducts) ? stored.selectedProducts : [];
        state.activeBrush = stored.activeBrush || null;
        state.assignments = Array.isArray(stored.assignments) ? stored.assignments : [];
        state.customHeightMode = stored.customHeightMode === true;
        state.customHeightPlans = Array.isArray(stored.customHeightPlans) ? [0, 1, 2].map((index) => Array.isArray(stored.customHeightPlans[index]) ? stored.customHeightPlans[index].map((height) => [100, 180, 205].includes(Number(height)) ? Number(height) : state.height) : []) : state.customHeightPlans;
        state.lengths = Array.isArray(stored.lengths) ? stored.lengths.slice(0, 3).map(snapLength) : state.lengths;
        if (Array.isArray(stored.interruptions)) {
          state.interruptions = state.interruptions.map((fallback, index) => {
            const saved = stored.interruptions[index] || {};
            return { enabled: saved.enabled === true, width: Math.max(0.5, Number(saved.width) || 1), position: Math.max(PLANNING_GRID, Number(saved.position) || PLANNING_GRID) };
          });
        } else if (stored.interruption && typeof stored.interruption === 'object' && stored.interruption.enabled === true) {
          const index = Math.min(2, Math.max(0, Number(stored.interruption.segment) || 0));
          state.interruptions[index] = { enabled: true, width: Math.max(0.5, Number(stored.interruption.width) || 1), position: Math.max(PLANNING_GRID, Number(stored.interruption.position) || PLANNING_GRID) };
        }
        state.interruptions.forEach((interruption, index) => {
          if (interruption.enabled && Array.isArray(stored.lengths)) {
            const interruptedLength = Number(stored.lengths[index]);
            if (Number.isFinite(interruptedLength)) state.lengths[index] = Math.max(3.1, interruptedLength);
          }
        });
        state.interruptionMode = stored.interruptionMode === true || state.interruptions.some((interruption) => interruption.enabled);
        if (Array.isArray(stored.heightChanges)) {
          state.heightChanges = state.heightChanges.map((fallback, index) => {
            const saved = stored.heightChanges[index] || {};
            const savedHeight = [100, 180, 205].includes(Number(saved.height)) ? Number(saved.height) : fallback.height;
            return { enabled: saved.enabled === true, height: savedHeight, position: Math.max(PLANNING_GRID, Number(saved.position) || PLANNING_GRID) };
          });
        }
      }
    } catch (error) {
      console.warn('Gespeicherte HELIX-Planung konnte nicht geladen werden.', error);
    }

    function saveState() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          step: state.step, height: state.height, shape: state.shape, lengths: state.lengths, interruptions: state.interruptions, interruptionMode: state.interruptionMode, heightChanges: state.heightChanges,
          selectedProducts: state.selectedProducts, activeBrush: state.activeBrush, assignments: state.assignments, customHeightMode: state.customHeightMode, customHeightPlans: state.customHeightPlans
        }));
      } catch (error) {}
    }

    function requiredHeights() {
      if (state.customHeightMode) {
        normalizeCustomHeightPlans();
        return [...new Set(state.customHeightPlans.slice(0, shapes[state.shape].segments).flat())].sort((a, b) => a - b);
      }
      const heights = new Set([state.height]);
      state.heightChanges.slice(0, shapes[state.shape].segments).forEach((change) => {
        if (change.enabled && change.height !== state.height) heights.add(change.height);
      });
      return [...heights].sort((a, b) => a - b);
    }

    function productAvailableAtHeight(key, height) {
      const variant = catalog[key]?.variants?.[height];
      return Boolean(variant && variant.available !== false);
    }

    function validProducts(height = state.height) {
      return Object.entries(catalog).filter(([, product]) => {
        const variant = product.variants[height];
        return Boolean(variant && variant.available !== false);
      }).sort((a, b) => a[1].sortOrder - b[1].sortOrder);
    }

    function productLabel(key) {
      const product = catalog[key];
      if (!product) return key;
      return product.subtitle || product.botanical || product.title;
    }

    function shortProductLabel(key, product) {
      const labels = {
        woerneri: 'Efeu', coloratus: 'Spindelstrauch', 'dentata-variegata': 'Kaukasischer Efeu',
        'lonicera-henryi': 'Geißblatt', 'clematis-snow-drift': 'Clematis',
        'hydrangea-take-a-chance': 'Kletterhortensie', 'genuss-geneva': 'Kiwi', 'genuss-szymanowski': 'Kiwi'
      };
      if (key.startsWith('color-')) return 'Color';
      return labels[key] || product.subtitle || product.botanical || product.title;
    }

    function productTitle(product) {
      if (!product?.subtitle || String(product.title).toLowerCase().includes(String(product.subtitle).toLowerCase())) {
        return product?.title || '';
      }
      return `${product.title} – ${product.subtitle}`;
    }

    function ensureSelections() {
      const heights = moduleHeights();
      const required = requiredHeights();
      const validKeys = new Set(Object.keys(catalog).filter((key) => required.some((height) => productAvailableAtHeight(key, height))));
      state.selectedProducts = state.selectedProducts.filter((key) => validKeys.has(key));
      state.assignments = state.assignments.map((key, index) => key && productAvailableAtHeight(key, heights[index] || state.height) ? key : null);
      if (!validKeys.has(state.activeBrush)) state.activeBrush = state.selectedProducts[0] || null;
    }

    function interruptionParts(segmentIndex) {
      const interruption = state.interruptions[segmentIndex];
      if (!interruption?.enabled || segmentIndex >= shapes[state.shape].segments) return null;
      const minimumTotal = PLANNING_GRID * 2 + 0.5;
      const total = Math.max(minimumTotal, Number(state.lengths[segmentIndex]) || minimumTotal);
      const width = Math.min(Math.max(0.5, Number(interruption.width) || 1), total - PLANNING_GRID * 2);
      const maximumPositionModules = Math.max(1, Math.floor(((total - width - PLANNING_GRID) + 0.000001) / PLANNING_GRID));
      const requestedPositionModules = Math.max(1, Math.ceil(((Number(interruption.position) || PLANNING_GRID) - 0.000001) / PLANNING_GRID));
      const leftModules = Math.min(requestedPositionModules, maximumPositionModules);
      const desiredLeft = Number((leftModules * PLANNING_GRID).toFixed(1));
      const desiredRight = Math.max(PLANNING_GRID, total - width - desiredLeft);
      const rightModules = Math.max(1, Math.ceil((desiredRight - 0.000001) / PLANNING_GRID));
      const left = Number((leftModules * PLANNING_GRID).toFixed(1));
      const right = Number((rightModules * PLANNING_GRID).toFixed(1));
      return { total, width, desiredLeft, desiredRight, leftModules, rightModules, left, right, planned: Number((left + width + right).toFixed(1)) };
    }

    function activeInterruptions() {
      return state.interruptions.slice(0, shapes[state.shape].segments).map((interruption, index) => ({ interruption, index })).filter(({ interruption }) => interruption.enabled);
    }

    function normalizeInterruptions() {
      activeInterruptions().forEach(({ interruption, index }) => {
        if (Number(state.lengths[index]) < PLANNING_GRID * 2 + 0.5) state.lengths[index] = 3.9;
        const parts = interruptionParts(index);
        interruption.width = parts.width;
        interruption.position = parts.desiredLeft;
      });
    }

    function segmentModules() {
      normalizeInterruptions();
      return state.lengths.slice(0, shapes[state.shape].segments).map((value, index) => {
        const parts = interruptionParts(index);
        return parts ? parts.leftModules + parts.rightModules : Math.max(1, Math.round(value / PLANNING_GRID));
      });
    }

    function normalizeCustomHeightPlans() {
      const counts = segmentModules();
      state.customHeightPlans = [0, 1, 2].map((segmentIndex) => {
        const count = counts[segmentIndex] || 0;
        const existing = Array.isArray(state.customHeightPlans[segmentIndex]) ? state.customHeightPlans[segmentIndex].slice(0, count) : [];
        while (existing.length < count) existing.push(state.height);
        return existing.map((height) => [100, 180, 205].includes(Number(height)) ? Number(height) : state.height);
      });
    }

    function normalizeHeightChanges() {
      const counts = segmentModules();
      state.heightChanges.forEach((change, index) => {
        if (index >= shapes[state.shape].segments || counts[index] < 2) change.enabled = false;
        if (change.height === state.height) change.height = [100, 180, 205].find((height) => height !== state.height) || 180;
        const maximumModules = Math.max(1, (counts[index] || 1) - 1);
        const requestedModules = Math.max(1, Math.round((Number(change.position) || PLANNING_GRID) / PLANNING_GRID));
        change.position = Number((Math.min(requestedModules, maximumModules) * PLANNING_GRID).toFixed(1));
      });
    }

    function segmentHeightPlan() {
      const counts = segmentModules();
      if (state.customHeightMode) {
        normalizeCustomHeightPlans();
        return counts.map((count, index) => state.customHeightPlans[index].slice(0, count));
      }
      normalizeHeightChanges();
      return counts.map((count, segmentIndex) => {
        const change = state.heightChanges[segmentIndex];
        const before = change.enabled ? Math.max(1, Math.round(change.position / PLANNING_GRID)) : count;
        return Array.from({ length: count }, (_, moduleIndex) => change.enabled && moduleIndex >= before ? change.height : state.height);
      });
    }

    function moduleHeights() {
      return segmentHeightPlan().flat();
    }

    function heightPlanSummary() {
      return segmentHeightPlan().map((heights, segmentIndex) => {
        const runs = [];
        heights.forEach((height) => {
          const previous = runs[runs.length - 1];
          if (previous && previous.height === height) previous.qty += 1;
          else runs.push({ height, qty: 1 });
        });
        return `Strecke ${String.fromCharCode(65 + segmentIndex)}: ${runs.map((run) => `${run.qty} × ${run.height} cm`).join(' · ')}`;
      }).join(' | ');
    }

    function snapLength(value) {
      const parsed = Number(value);
      const modules = Math.max(1, Math.ceil(((Number.isFinite(parsed) ? parsed : PLANNING_GRID) - 0.000001) / PLANNING_GRID));
      return Number((modules * PLANNING_GRID).toFixed(1));
    }

    function syncAssignments() {
      ensureSelections();
      const modules = segmentModules().reduce((sum, count) => sum + count, 0);
      const heights = moduleHeights();
      if (state.assignments.length > modules) state.assignments.length = modules;
      while (state.assignments.length < modules) state.assignments.push(null);
      state.assignments = state.assignments.map((key, index) => {
        const height = heights[index] || state.height;
        if (key && productAvailableAtHeight(key, height)) return key;
        return state.selectedProducts.find((candidate) => productAvailableAtHeight(candidate, height)) || null;
      });
      state.selectedProducts = [...new Set([...state.selectedProducts, ...state.assignments.filter(Boolean)])];
    }

    function calculate() {
      syncAssignments();
      if (!state.selectedProducts.length || state.assignments.some((key) => !key)) return null;
      const heightsBySegment = segmentHeightPlan();
      const heightsByModule = heightsBySegment.flat();
      const maximumHeight = Math.max(...heightsByModule, state.height);

      const segmentModuleCounts = segmentModules();
      const modules = segmentModuleCounts.reduce((sum, count) => sum + count, 0);
      const interruptionCount = activeInterruptions().length;
      const posts = modules + 1 + interruptionCount;
      const levelsFor = (height) => Number(config.levels[String(height)]) || 0;
      const runsForSegment = (index) => {
        const heights = heightsBySegment[index] || [];
        const parts = interruptionParts(index);
        return parts ? [heights.slice(0, parts.leftModules), heights.slice(parts.leftModules)] : [heights];
      };
      const endBrackets = segmentModuleCounts.reduce((sum, count, index) => sum + runsForSegment(index).reduce((runSum, run) => {
        if (!run.length) return runSum;
        return runSum + levelsFor(run[0]) + levelsFor(run[run.length - 1]) + run.slice(1).reduce((extra, height, moduleIndex) => extra + Math.abs(levelsFor(run[moduleIndex]) - levelsFor(height)), 0);
      }, 0), 0);
      const middleBrackets = segmentModuleCounts.reduce((sum, count, index) => sum + runsForSegment(index).reduce((runSum, run) => {
        return runSum + run.slice(1).reduce((boundarySum, height, moduleIndex) => boundarySum + Math.min(levelsFor(run[moduleIndex]), levelsFor(height)), 0);
      }, 0), 0);

      const postHeightCounts = {};
      const addPost = (height, delta = 1) => { postHeightCounts[height] = (postHeightCounts[height] || 0) + delta; };
      heightsBySegment.forEach((heights, segmentIndex) => {
        runsForSegment(segmentIndex).forEach((run) => {
          if (!run.length) return;
          addPost(run[0]);
          run.slice(1).forEach((height, index) => addPost(Math.max(run[index], height)));
          addPost(run[run.length - 1]);
        });
      });
      const cornerPairs = state.shape === 'straight' ? [] : state.shape === 'l' ? [[0, 1]] : [[0, 1], [1, 2]];
      cornerPairs.forEach(([leftSegment, rightSegment]) => {
        const leftHeight = heightsBySegment[leftSegment]?.[heightsBySegment[leftSegment].length - 1];
        const rightHeight = heightsBySegment[rightSegment]?.[0];
        if (!leftHeight || !rightHeight) return;
        addPost(leftHeight, -1); addPost(rightHeight, -1); addPost(Math.max(leftHeight, rightHeight));
      });

      const counts = state.assignments.reduce((acc, key, index) => {
        const height = heightsByModule[index] || state.height;
        const countKey = `${key}::${height}`;
        acc[countKey] = (acc[countKey] || 0) + 1;
        return acc;
      }, {});
      const hedgeRows = Object.entries(counts).map(([countKey, qty]) => {
        const splitAt = countKey.lastIndexOf('::');
        const key = countKey.slice(0, splitAt);
        const height = Number(countKey.slice(splitAt + 2));
        const product = catalog[key];
        const variant = product.variants[height];
        return { name: productTitle(product), detail: `${product.botanical}, ${height} cm`, article: variant.article, qty, price: variant.price, id: variant.variantId, type: 'hedge', key, height, image: variant.image || product.image };
      });
      const postRows = Object.entries(postHeightCounts).filter(([, qty]) => qty > 0).sort(([a], [b]) => Number(a) - Number(b)).map(([height, qty]) => {
        const post = config.accessories.posts[String(height)];
        return post ? { name: post.name, detail: `grün, passend bis ${height} cm Heckenhöhe`, qty, price: Number(post.price) || 0, id: Number(post.variantId), type: 'accessory', kind: 'post', height: Number(height), image: config.resultImages?.post || '' } : null;
      }).filter(Boolean);
      if (!postRows.length) return null;
      const rows = [
        ...hedgeRows,
        ...postRows,
        { name: config.accessories.end.name, detail: 'grün, einseitig', qty: endBrackets, price: Number(config.accessories.end.price) || 0, id: Number(config.accessories.end.variantId), type: 'accessory', kind: 'end' },
        { name: config.accessories.middle.name, detail: 'grün, beidseitig', qty: middleBrackets, price: Number(config.accessories.middle.price) || 0, id: Number(config.accessories.middle.variantId), type: 'accessory', kind: 'middle' }
      ].filter((row) => row.qty > 0 && row.id > 0);

      return { modules, posts, endBrackets, middleBrackets, brackets: endBrackets + middleBrackets, rows, total: rows.reduce((sum, row) => sum + row.qty * row.price, 0), maximumHeight };
    }

    function showStep(number, shouldScroll = true) {
      state.step = number;
      qa('[data-step]').forEach((panel) => { panel.hidden = Number(panel.dataset.step) !== number; });
      qa('[data-step-link]').forEach((button) => {
        const step = Number(button.dataset.stepLink);
        button.classList.toggle('is-active', step === number);
        button.classList.toggle('is-complete', step < number);
      });
      if (shouldScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      saveState();
    }

    function addProduct(key) {
      if (!catalog[key]?.variants[state.height]) return;
      syncAssignments();
      if (!state.selectedProducts.length) {
        state.selectedProducts = [key];
        state.activeBrush = key;
        state.assignments = Array(segmentModules().reduce((sum, count) => sum + count, 0)).fill(key);
      } else if (!state.selectedProducts.includes(key)) {
        state.selectedProducts.push(key);
        state.activeBrush = key;
        const donor = state.selectedProducts[0];
        const donorIndex = state.assignments.lastIndexOf(donor);
        if (donorIndex >= 0) state.assignments[donorIndex] = key;
      }
      state.chooserOpen = false;
      renderAll();
    }

    function removeProduct(key) {
      if (!state.selectedProducts.includes(key)) return;
      if (state.selectedProducts.length === 1) {
        toast('Mindestens eine Heckensorte muss ausgewählt bleiben.');
        return;
      }
      const replacement = state.selectedProducts.find((entry) => entry !== key);
      state.selectedProducts = state.selectedProducts.filter((entry) => entry !== key);
      state.assignments = state.assignments.map((entry) => entry === key ? replacement : entry);
      state.activeBrush = replacement;
      renderAll();
    }

    function changeProductCount(key, delta) {
      syncAssignments();
      const primary = state.selectedProducts[0];
      const count = state.assignments.filter((entry) => entry === key).length;
      if (delta > 0) {
        const donor = state.selectedProducts.find((entry) => entry !== key && state.assignments.includes(entry));
        if (!donor) { toast('Alle Elemente sind bereits dieser Sorte zugeordnet.'); return; }
        const donorIndex = state.assignments.lastIndexOf(donor);
        if (donorIndex >= 0) state.assignments[donorIndex] = key;
      } else if (count > 0) {
        if (key === primary && count === 1 && state.selectedProducts.length === 1) return;
        const index = state.assignments.lastIndexOf(key);
        if (index >= 0) state.assignments[index] = key === primary ? (state.selectedProducts.find((entry) => entry !== key) || key) : primary;
        if (key !== primary && count === 1) state.selectedProducts = state.selectedProducts.filter((entry) => entry !== key);
      }
      renderAll();
    }

    function setProductForHeight(height, key) {
      syncAssignments();
      if (!productAvailableAtHeight(key, height)) return;
      const heights = moduleHeights();
      state.assignments = state.assignments.map((assignment, index) => heights[index] === height ? key : assignment);
      state.selectedProducts = [...new Set(state.assignments.filter(Boolean))];
      state.activeBrush = key;
      renderAll();
    }

    function changeProductCountForHeight(height, key, delta) {
      syncAssignments();
      if (!productAvailableAtHeight(key, height)) return;
      const heights = moduleHeights();
      const indices = heights.map((value, index) => value === height ? index : -1).filter((index) => index >= 0);
      const ownIndices = indices.filter((index) => state.assignments[index] === key);
      if (delta > 0) {
        const donorIndex = [...indices].reverse().find((index) => state.assignments[index] && state.assignments[index] !== key);
        if (donorIndex === undefined) {
          toast(ownIndices.length ? 'Alle Elemente dieser Höhe sind bereits dieser Sorte zugeordnet.' : 'Bitte zuerst eine Hauptsorte für diese Höhe auswählen.');
          return;
        }
        state.assignments[donorIndex] = key;
      } else {
        if (!ownIndices.length) return;
        const replacement = indices.map((index) => state.assignments[index]).find((candidate) => candidate && candidate !== key);
        if (!replacement) {
          toast('Mindestens eine zweite Heckensorte auswählen, bevor die Menge reduziert wird.');
          return;
        }
        state.assignments[ownIndices[ownIndices.length - 1]] = replacement;
      }
      state.selectedProducts = [...new Set(state.assignments.filter(Boolean))];
      state.activeBrush = key;
      renderAll();
    }

    function renderProductsByHeight(host) {
      syncAssignments();
      const heights = moduleHeights();
      const required = requiredHeights();
      const familyMeta = { evergreen: 'Immergrüne Hecken', flowering: 'Blühende Hecken', enjoyment: 'Genuss-Hecken' };
      const groups = required.map((height) => {
        const indices = heights.map((value, index) => value === height ? index : -1).filter((index) => index >= 0);
        const heightCounts = indices.reduce((result, index) => {
          const key = state.assignments[index];
          if (key) result[key] = (result[key] || 0) + 1;
          return result;
        }, {});
        const assignedKeys = Object.keys(heightCounts);
        const products = validProducts(height);
        const showAllProducts = !assignedKeys.length || state.expandedHeightChoices[height] === true;
        const families = products.reduce((result, entry) => {
          (result[entry[1].family || 'evergreen'] ||= []).push(entry);
          return result;
        }, {});
        const productMarkup = ['evergreen', 'flowering', 'enjoyment'].filter((family) => families[family]?.some(([key]) => showAllProducts || assignedKeys.includes(key))).map((family) => `<section class="hx__height-product-family"><h4>${familyMeta[family]}</h4><div class="hx__height-product-options">${families[family].filter(([key]) => showAllProducts || assignedKeys.includes(key)).map(([key, product]) => {
          const variant = product.variants[height];
          const qty = heightCounts[key] || 0;
          const selected = qty > 0;
          const image = variant.image || product.image;
          const controls = assignedKeys.length
            ? `<div class="hx__height-quantity"><div><button type="button" data-height-qty-minus="${height}" data-height-product-key="${escapeHtml(key)}" aria-label="Ein Element weniger"${qty === 0 ? ' disabled' : ''}>−</button><strong>${qty}</strong><button type="button" data-height-qty-plus="${height}" data-height-product-key="${escapeHtml(key)}" aria-label="Ein Element mehr"${qty === indices.length ? ' disabled' : ''}>+</button></div><small>von ${indices.length}</small></div>`
            : `<button type="button" class="hx__height-primary-select" data-height-product="${height}" data-height-product-key="${escapeHtml(key)}">Auswählen</button>`;
          return `<div class="hx__height-product-option${selected ? ' is-selected' : ''}">${image ? `<img src="${escapeHtml(image)}" alt="">` : ''}<span><b>${escapeHtml(product.subtitle || product.title)}</b><small>${escapeHtml(product.botanical)}</small></span>${controls}</div>`;
        }).join('')}</div></section>`).join('');
        const selectionSummary = assignedKeys.length
          ? assignedKeys.map((key) => `${heightCounts[key]} × ${escapeHtml(productLabel(key))}`).join(' · ')
          : 'Bitte eine Heckensorte auswählen.';
        const hasMoreProducts = products.some(([key]) => !assignedKeys.includes(key));
        const moreButton = assignedKeys.length && hasMoreProducts
          ? `<button type="button" class="hx__height-more" data-toggle-height-products="${height}">${showAllProducts ? 'Weitere Sorten ausblenden' : 'Weitere Heckensorte ergänzen'}</button>`
          : '';
        return `<article class="hx__height-product-group"><header><div><span>Heckensorte für</span><h3>${height} cm</h3></div><b>${indices.length} ${indices.length === 1 ? 'Element' : 'Elemente'}</b></header><p class="hx__height-product-current">${assignedKeys.length ? 'Verteilung: ' : ''}${selectionSummary}</p>${productMarkup || '<p>Für diese Höhe ist derzeit keine Heckensorte verfügbar.</p>'}${moreButton}</article>`;
      }).join('');
      host.innerHTML = `<div class="hx__height-product-groups"><div class="hx__composition-intro"><div><b>Heckensorten nach Höhe auswählen</b><span>Für jeden Höhenabschnitt wird die passende Shopify-Variante verwendet.</span></div><strong>${state.assignments.filter(Boolean).length} / ${heights.length}</strong></div>${groups}</div>`;
      qa('[data-height-product]').forEach((button) => button.addEventListener('click', () => setProductForHeight(Number(button.dataset.heightProduct), button.dataset.heightProductKey)));
      qa('[data-height-qty-minus]').forEach((button) => button.addEventListener('click', () => changeProductCountForHeight(Number(button.dataset.heightQtyMinus), button.dataset.heightProductKey, -1)));
      qa('[data-height-qty-plus]').forEach((button) => button.addEventListener('click', () => changeProductCountForHeight(Number(button.dataset.heightQtyPlus), button.dataset.heightProductKey, 1)));
      qa('[data-toggle-height-products]').forEach((button) => button.addEventListener('click', () => {
        const height = Number(button.dataset.toggleHeightProducts);
        state.expandedHeightChoices[height] = state.expandedHeightChoices[height] !== true;
        renderProducts();
      }));
    }

    function renderProducts() {
      ensureSelections();
      syncAssignments();
      const products = validProducts();
      const host = q('[data-product-grid]');
      const familyMeta = {
        evergreen: 'Immergrüne Hecken', flowering: 'Blühende Hecken', enjoyment: 'Genuss-Hecken'
      };
      const propertiesMarkup = (tags) => tags.filter((tag) =>
        tag && !String(tag).toLowerCase().includes('winterhart')
      ).map((tag) =>
        `<span class="hx__property">${iconFor(tag)}<b>${escapeHtml(tag)}</b></span>`
      ).join('');

      if (requiredHeights().length > 1) {
        renderProductsByHeight(host);
        return;
      }

      if (!state.selectedProducts.length) {
        state.chooserOpen = true;
      }

      const counts = state.assignments.reduce((acc, key) => {
        if (key) acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});
      const total = segmentModules().reduce((sum, count) => sum + count, 0);

      const selectedMarkup = state.selectedProducts.map((key, index) => {
        const product = catalog[key];
        const variant = product.variants[state.height];
        const image = variant.image || product.image;
        const qty = counts[key] || 0;
        return `<article class="hx__composition-card${index === 0 ? ' is-primary' : ''}">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.botanical)}" loading="lazy">` : ''}
          <div class="hx__composition-copy"><span class="hx__composition-kicker">${index === 0 ? 'Hauptsorte' : 'Ergänzende Sorte'}</span><h3>${escapeHtml(productTitle(product))}</h3><p>${escapeHtml(product.botanical)}</p><div class="hx__properties">${propertiesMarkup(product.tags)}</div></div>
          <div class="hx__quantity"><span>Elemente</span><div><button type="button" data-qty-minus="${escapeHtml(key)}" aria-label="Ein Element weniger">−</button><strong>${qty}</strong><button type="button" data-qty-plus="${escapeHtml(key)}" aria-label="Ein Element mehr">+</button></div><small>von ${total}</small>${index > 0 ? `<button type="button" class="hx__remove-sort" data-remove-sort="${escapeHtml(key)}">Entfernen</button>` : ''}</div>
        </article>`;
      }).join('');

      const available = products.filter(([key]) => !state.selectedProducts.includes(key));
      const grouped = available.reduce((acc, entry) => { (acc[entry[1].family || 'evergreen'] ||= []).push(entry); return acc; }, {});
      const chooserHeights = requiredHeights().map((height) => `${height} cm`).join(' und ');
      const chooser = state.chooserOpen ? `<div class="hx__sort-chooser"><div class="hx__chooser-head"><div><b>${state.selectedProducts.length ? 'Weitere Heckensorte wählen' : 'Hauptsorte wählen'}</b><span>Es werden nur Sorten angezeigt, die für ${chooserHeights} verfügbar sind.</span></div>${state.selectedProducts.length ? '<button type="button" data-close-chooser>Schließen</button>' : ''}</div>${['evergreen','flowering','enjoyment'].filter((family) => grouped[family]?.length).map((family) => `<section><h4>${familyMeta[family]}</h4><div class="hx__chooser-grid">${grouped[family].map(([key, product]) => { const variant=product.variants[state.height]; const image=variant.image||product.image; return `<button type="button" class="hx__chooser-item" data-add-sort="${escapeHtml(key)}">${image ? `<img src="${escapeHtml(image)}" alt="">` : ''}<span><b>${escapeHtml(product.subtitle || product.title)}</b><small>${escapeHtml(product.botanical)}</small></span><em>Hinzufügen</em></button>`; }).join('')}</div></section>`).join('')}</div>` : '';

      host.innerHTML = `<div class="hx__composition"><div class="hx__composition-intro"><div><b>Ihre Hecke besteht aus ${total} Elementen.</b><span>Wählen Sie eine Hauptsorte und ersetzen Sie bei Bedarf einzelne Elemente.</span></div><strong>${state.assignments.filter(Boolean).length} / ${total}</strong></div>${selectedMarkup || ''}${state.selectedProducts.length && available.length ? `<button type="button" class="hx__add-sort" data-open-chooser><span>+</span><b>Weitere Sorte hinzufügen</b><small>Einzelne Elemente durch eine andere Heckensorte ersetzen.</small></button>` : ''}${chooser}</div>`;

      qa('[data-add-sort]').forEach((button) => button.addEventListener('click', () => addProduct(button.dataset.addSort)));
      q('[data-open-chooser]')?.addEventListener('click', () => { state.chooserOpen = true; renderProducts(); });
      q('[data-close-chooser]')?.addEventListener('click', () => { state.chooserOpen = false; renderProducts(); });
      qa('[data-remove-sort]').forEach((button) => button.addEventListener('click', () => removeProduct(button.dataset.removeSort)));
      qa('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => changeProductCount(button.dataset.qtyMinus, -1)));
      qa('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => changeProductCount(button.dataset.qtyPlus, 1)));
    }

    function renderMeasures() {
      const labels = state.shape === 'straight' ? ['Länge A'] : state.shape === 'l' ? ['Länge A', 'Länge B'] : ['Länge A', 'Länge B', 'Länge C'];
      normalizeInterruptions();
      normalizeHeightChanges();
      const moduleCounts = segmentModules();
      const interruptionMarkup = state.interruptionMode ? `<div class="hx__interruption-fields"><strong>Unterbrechungen festlegen</strong>
        <div class="hx__gap-segment-list">${labels.map((label, index) => `<label><input type="checkbox" data-gap-toggle="${index}"${state.interruptions[index].enabled ? ' checked' : ''}><span>Strecke ${String.fromCharCode(65 + index)}</span></label>`).join('')}</div>
        ${labels.map((label, index) => {
          const interruption = state.interruptions[index];
          if (!interruption.enabled) return '';
          const parts = interruptionParts(index);
          const maximumPositionModules = Math.max(1, parts.leftModules + parts.rightModules - 1);
          const positionOptions = Array.from({ length: maximumPositionModules }, (_, optionIndex) => {
            const moduleCount = optionIndex + 1;
            const value = Number((moduleCount * PLANNING_GRID).toFixed(1));
            return `<option value="${value.toFixed(1)}"${Math.abs(value - interruption.position) < 0.01 ? ' selected' : ''}>Nach ${moduleCount} ${moduleCount === 1 ? 'Element' : 'Elementen'} – ${value.toFixed(2).replace('.', ',')} m</option>`;
          }).join('');
          return `<div class="hx__gap-settings"><b>Strecke ${String.fromCharCode(65 + index)}</b><div><label for="hx-gap-width-${config.sectionId}-${index}">Breite der Unterbrechung</label><input id="hx-gap-width-${config.sectionId}-${index}" data-gap-width="${index}" type="number" min="0.5" max="5" step="0.1" value="${interruption.width.toFixed(1)}"><small>Zum Beispiel für Tor, Weg, Zufahrt oder Gestaltungselement</small></div><div><label for="hx-gap-position-${config.sectionId}-${index}">Position der Unterbrechung</label><select id="hx-gap-position-${config.sectionId}-${index}" data-gap-position="${index}">${positionOptions}</select><small>Im festen 1,30-m-Raster ab Streckenanfang</small></div></div>`;
        }).join('')}
      </div>` : '';
      if (state.customHeightMode) normalizeCustomHeightPlans();
      const heightChangeMarkup = state.interruptionMode ? `<div class="hx__height-change-fields"><strong>Höhen individuell anordnen</strong>
        <div class="hx__height-base"><span>Elemente einzeln auf 100, 180 oder 205 cm einstellen und anschließend verschieben.</span><label class="hx__height-mode-toggle"><input type="checkbox" data-custom-height-mode${state.customHeightMode ? ' checked' : ''}><b>${state.customHeightMode ? 'Aktiviert' : 'Aktivieren'}</b></label></div>
        ${state.customHeightMode ? labels.map((label, segmentIndex) => {
          const parts = interruptionParts(segmentIndex);
          const gapAfter = parts ? parts.leftModules : -1;
          const elements = state.customHeightPlans[segmentIndex].map((height, elementIndex) => {
            const options = [100, 180, 205].map((option) => `<option value="${option}"${option === height ? ' selected' : ''}>${option} cm</option>`).join('');
            const gap = gapAfter === elementIndex + 1 ? `<span class="hx__height-gap">Unterbrechung<br>${parts.width.toFixed(2).replace('.', ',')} m</span>` : '';
            return `<div class="hx__height-element" draggable="true" data-height-element="${elementIndex}" data-height-segment="${segmentIndex}"><span>${String.fromCharCode(65 + segmentIndex)}${elementIndex + 1}</span><select data-element-height="${elementIndex}" data-height-segment="${segmentIndex}" aria-label="Höhe Element ${elementIndex + 1}">${options}</select><div><button type="button" data-height-move="-1" data-height-element="${elementIndex}" data-height-segment="${segmentIndex}" aria-label="Nach links verschieben">←</button><button type="button" data-height-move="1" data-height-element="${elementIndex}" data-height-segment="${segmentIndex}" aria-label="Nach rechts verschieben">→</button></div></div>${gap}`;
          }).join('');
          return `<section class="hx__height-editor"><header><b>Strecke ${String.fromCharCode(65 + segmentIndex)}</b><small>${moduleCounts[segmentIndex]} ${moduleCounts[segmentIndex] === 1 ? 'Element' : 'Elemente'}</small></header><div class="hx__height-strip">${elements}</div><p>Ziehen oder mit den Pfeilen verschieben. Die Unterbrechung bleibt an ihrer geplanten Position.</p></section>`;
        }).join('') : '<p class="hx__height-mode-help">Optional: Aktivieren Sie den visuellen Editor nur, wenn einzelne Heckenelemente unterschiedliche Höhen erhalten sollen.</p>'}
      </div>` : '';
      q('[data-measures]').innerHTML = labels.map((label, index) => {
        const interrupted = state.interruptions[index].enabled;
        return `<div class="hx__measure"><label for="hx-length-${config.sectionId}-${index}">${label}</label><div><input id="hx-length-${config.sectionId}-${index}" data-length="${index}" type="number" min="${interrupted ? '3.1' : PLANNING_GRID}" max="52" step="${interrupted ? '0.1' : PLANNING_GRID}" value="${state.lengths[index].toFixed(1)}"><span>m</span></div>${interrupted ? '<small>Gesamtmaß inklusive Unterbrechung</small>' : ''}</div>`;
      }).join('') + interruptionMarkup + heightChangeMarkup;
      const refreshPositionOptions = (index) => {
        const select = q(`[data-gap-position="${index}"]`);
        const parts = interruptionParts(index);
        if (!select || !parts) return;
        const maximumPositionModules = Math.max(1, parts.leftModules + parts.rightModules - 1);
        select.innerHTML = Array.from({ length: maximumPositionModules }, (_, optionIndex) => {
          const moduleCount = optionIndex + 1;
          const value = Number((moduleCount * PLANNING_GRID).toFixed(1));
          return `<option value="${value.toFixed(1)}"${Math.abs(value - state.interruptions[index].position) < 0.01 ? ' selected' : ''}>Nach ${moduleCount} ${moduleCount === 1 ? 'Element' : 'Elementen'} – ${value.toFixed(2).replace('.', ',')} m</option>`;
        }).join('');
      };
      qa('[data-length]').forEach((input) => input.addEventListener('input', () => {
        const index = Number(input.dataset.length);
        state.lengths[index] = state.interruptions[index].enabled
          ? Math.max(3.1, Number(input.value) || 3.1)
          : snapLength(input.value);
        normalizeInterruptions();
        refreshPositionOptions(index);
        syncAssignments(); renderPlanner(); renderSummary(); renderResult();
      }));
      qa('[data-length]').forEach((input) => input.addEventListener('change', () => {
        const index = Number(input.dataset.length);
        input.value = state.lengths[index].toFixed(1);
        if (state.interruptions[index].enabled) {
          normalizeInterruptions();
          normalizeCustomHeightPlans();
          syncAssignments();
          renderMeasures(); renderPlanner(); renderSummary(); renderResult();
        }
      }));
      qa('[data-gap-toggle]').forEach((input) => input.addEventListener('change', () => {
        const index = Number(input.dataset.gapToggle);
        state.interruptions[index].enabled = input.checked;
        if (!input.checked) state.lengths[index] = snapLength(state.lengths[index]);
        normalizeInterruptions(); syncAssignments(); renderMeasures(); renderPlanner(); renderSummary(); renderResult();
      }));
      qa('[data-gap-width]').forEach((input) => input.addEventListener('input', () => {
        const index = Number(input.dataset.gapWidth);
        state.interruptions[index].width = Math.max(0.5, Number(input.value) || 0.5);
        normalizeInterruptions(); refreshPositionOptions(index); syncAssignments(); renderPlanner(); renderSummary(); renderResult();
      }));
      qa('[data-gap-position]').forEach((select) => select.addEventListener('change', () => {
        const index = Number(select.dataset.gapPosition);
        state.interruptions[index].position = Math.max(PLANNING_GRID, Number(select.value) || PLANNING_GRID);
        normalizeInterruptions(); syncAssignments(); renderPlanner(); renderSummary(); renderResult();
      }));
      qa('[data-gap-width]').forEach((input) => input.addEventListener('change', () => {
        input.value = state.interruptions[Number(input.dataset.gapWidth)].width.toFixed(1);
        renderMeasures(); renderPlanner(); renderSummary(); renderResult();
      }));
      q('[data-custom-height-mode]')?.addEventListener('change', (event) => {
        state.customHeightMode = event.target.checked;
        state.heightChanges.forEach((change) => { change.enabled = false; });
        normalizeCustomHeightPlans(); ensureSelections(); syncAssignments(); renderAll();
      });
      qa('[data-element-height]').forEach((select) => select.addEventListener('change', () => {
        const segmentIndex = Number(select.dataset.heightSegment);
        const elementIndex = Number(select.dataset.elementHeight);
        state.customHeightPlans[segmentIndex][elementIndex] = Number(select.value);
        ensureSelections(); syncAssignments(); renderAll();
      }));
      const moveHeightElement = (segmentIndex, fromIndex, toIndex) => {
        const plan = state.customHeightPlans[segmentIndex];
        if (!plan || fromIndex === toIndex || toIndex < 0 || toIndex >= plan.length) return;
        const [height] = plan.splice(fromIndex, 1);
        plan.splice(toIndex, 0, height);
        ensureSelections(); syncAssignments(); renderAll();
      };
      qa('[data-height-move]').forEach((button) => button.addEventListener('click', () => moveHeightElement(Number(button.dataset.heightSegment), Number(button.dataset.heightElement), Number(button.dataset.heightElement) + Number(button.dataset.heightMove))));
      let draggedHeightElement = null;
      qa('.hx__height-element[data-height-element]').forEach((element) => {
        element.addEventListener('dragstart', () => { draggedHeightElement = { segment: Number(element.dataset.heightSegment), index: Number(element.dataset.heightElement) }; element.classList.add('is-dragging'); });
        element.addEventListener('dragend', () => { draggedHeightElement = null; element.classList.remove('is-dragging'); });
        element.addEventListener('dragover', (event) => event.preventDefault());
        element.addEventListener('drop', (event) => {
          event.preventDefault();
          const targetSegment = Number(element.dataset.heightSegment);
          if (!draggedHeightElement || draggedHeightElement.segment !== targetSegment) return;
          moveHeightElement(targetSegment, draggedHeightElement.index, Number(element.dataset.heightElement));
        });
      });
    }

    function planSvg() {
      const lengths = state.lengths.slice(0, shapes[state.shape].segments);
      const modules = segmentModules();
      const heightsBySegment = segmentHeightPlan();
      const plannedLengths = lengths.map((length, index) => interruptionParts(index)?.planned || length);
      const baseSegments = state.shape === 'straight'
        ? [{ from: [0, 0], to: [plannedLengths[0], 0], label: 'A', length: lengths[0], plannedLength: plannedLengths[0], modules: modules[0], index: 0 }]
        : state.shape === 'l'
          ? [
              { from: [0, plannedLengths[0]], to: [0, 0], label: 'A', length: lengths[0], plannedLength: plannedLengths[0], modules: modules[0], index: 0 },
              { from: [0, 0], to: [plannedLengths[1], 0], label: 'B', length: lengths[1], plannedLength: plannedLengths[1], modules: modules[1], index: 1 }
            ]
          : [
              { from: [0, plannedLengths[0]], to: [0, 0], label: 'A', length: lengths[0], plannedLength: plannedLengths[0], modules: modules[0], index: 0 },
              { from: [0, 0], to: [plannedLengths[1], 0], label: 'B', length: lengths[1], plannedLength: plannedLengths[1], modules: modules[1], index: 1 },
              { from: [plannedLengths[1], 0], to: [plannedLengths[1], plannedLengths[2]], label: 'C', length: lengths[2], plannedLength: plannedLengths[2], modules: modules[2], index: 2 }
            ];
      const lerpPoint = (from, to, fraction) => [from[0] + (to[0] - from[0]) * fraction, from[1] + (to[1] - from[1]) * fraction];
      const openings = [];
      const drawingSegments = baseSegments.flatMap((segment) => {
        const parts = interruptionParts(segment.index);
        if (!parts) return [{ from: segment.from, to: segment.to, modules: segment.modules, index: segment.index, moduleOffset: 0 }];
        const beforeGap = parts.left / parts.planned;
        const afterGap = (parts.left + parts.width) / parts.planned;
        const gapStart = lerpPoint(segment.from, segment.to, beforeGap);
        const gapEnd = lerpPoint(segment.from, segment.to, afterGap);
        openings.push({ from: gapStart, to: gapEnd, width: parts.width, segmentIndex: segment.index });
        return [
          { from: segment.from, to: gapStart, modules: parts.leftModules, index: segment.index, moduleOffset: 0 },
          { from: gapEnd, to: segment.to, modules: parts.rightModules, index: segment.index, moduleOffset: parts.leftModules }
        ];
      });
      const points = baseSegments.flatMap((segment) => [segment.from, segment.to]);
      const xs = points.map((point) => point[0]);
      const ys = points.map((point) => point[1]);
      const minX = Math.min(...xs), maxX = Math.max(...xs), minY = Math.min(...ys), maxY = Math.max(...ys);
      const width = Math.max(maxX - minX, PLANNING_GRID);
      const height = Math.max(maxY - minY, PLANNING_GRID);
      const naturalScale = 62 / PLANNING_GRID;
      const maxPlotWidth = state.shape === 'straight' ? 650 : 480;
      const scale = Math.min(naturalScale, maxPlotWidth / width, 165 / height);
      const offsetX = 400 - ((minX + maxX) / 2) * scale;
      const offsetY = 150 + ((minY + maxY) / 2) * scale;
      const point = ([x, y]) => [offsetX + x * scale, offsetY - y * scale];
      const moduleMarkup = [];
      const endBracketMarkup = [];
      const middleBracketMarkup = [];
      const postMarkup = [];
      const dimensionMarkup = [];
      const heightChangeMarkup = [];
      const openingMarkup = [];
      const seenPosts = new Set();
      const seenHeightChanges = new Set();

      drawingSegments.forEach((segment) => {
        const [x1, y1] = point(segment.from);
        const [x2, y2] = point(segment.to);
        const dx = x2 - x1, dy = y2 - y1;
        const magnitude = Math.max(Math.hypot(dx, dy), 1);
        const tx = dx / magnitude, ty = dy / magnitude;
        const nx = -dy / magnitude, ny = dx / magnitude;
        for (let index = 0; index < segment.modules; index += 1) {
          const start = index / segment.modules;
          const end = (index + 1) / segment.modules;
          // Jedes Rasterfeld ist maßstäblich gleich lang. Die optische Fuge
          // wird deshalb in Pixeln und nicht prozentual zur Schenkellänge
          // definiert; so wirken kurze und lange Schenkel identisch.
          const moduleLength = magnitude / segment.modules;
          const moduleInset = Math.min(4, moduleLength * .12);
          const moduleX1 = x1 + dx * start + tx * moduleInset;
          const moduleY1 = y1 + dy * start + ty * moduleInset;
          const moduleX2 = x1 + dx * end - tx * moduleInset;
          const moduleY2 = y1 + dy * end - ty * moduleInset;
          moduleMarkup.push(`<line class="hx__plan-module-shadow" x1="${moduleX1.toFixed(1)}" y1="${(moduleY1 + 3).toFixed(1)}" x2="${moduleX2.toFixed(1)}" y2="${(moduleY2 + 3).toFixed(1)}"/><line class="hx__plan-module" x1="${moduleX1.toFixed(1)}" y1="${moduleY1.toFixed(1)}" x2="${moduleX2.toFixed(1)}" y2="${moduleY2.toFixed(1)}"/>`);
          const px = x1 + dx * start, py = y1 + dy * start;
          const modulePosition = segment.moduleOffset + index;
          const segmentHeights = heightsBySegment[segment.index] || [];
          const heightChangeKey = `${segment.index}:${modulePosition}`;
          if (modulePosition > 0 && segmentHeights[modulePosition] !== segmentHeights[modulePosition - 1] && !seenHeightChanges.has(heightChangeKey)) {
            heightChangeMarkup.push(`<line class="hx__plan-height-change" x1="${(px - nx * 8).toFixed(1)}" y1="${(py - ny * 8).toFixed(1)}" x2="${(px + nx * 8).toFixed(1)}" y2="${(py + ny * 8).toFixed(1)}"/>`);
            seenHeightChanges.add(heightChangeKey);
          }
          const key = `${px.toFixed(1)}:${py.toFixed(1)}`;
          if (!seenPosts.has(key)) {
            postMarkup.push(`<circle class="hx__plan-post" cx="${px.toFixed(1)}" cy="${py.toFixed(1)}" r="4"/>`);
            seenPosts.add(key);
          }
          if (index === 0) {
            // End- und Zwischenpfahlbügel verwenden denselben Maßstab. Der
            // Endpfahlbügel beginnt im Pfostenmittelpunkt; der anschließend
            // darüber gezeichnete Pfosten lässt ihn bündig am Pfostenrand
            // beginnen, ohne sichtbaren Abstand.
            endBracketMarkup.push(`<line class="hx__plan-end-bracket" x1="${(px + tx * 5).toFixed(1)}" y1="${(py + ty * 5).toFixed(1)}" x2="${(px + tx * 9).toFixed(1)}" y2="${(py + ty * 9).toFixed(1)}"/>`);
          } else {
            middleBracketMarkup.push(`<line class="hx__plan-middle-bracket" x1="${(px - tx * 9).toFixed(1)}" y1="${(py - ty * 9).toFixed(1)}" x2="${(px + tx * 9).toFixed(1)}" y2="${(py + ty * 9).toFixed(1)}"/>`);
          }
        }
        const endKey = `${x2.toFixed(1)}:${y2.toFixed(1)}`;
        if (!seenPosts.has(endKey)) {
          postMarkup.push(`<circle class="hx__plan-post" cx="${x2.toFixed(1)}" cy="${y2.toFixed(1)}" r="4"/>`);
          seenPosts.add(endKey);
        }
        endBracketMarkup.push(`<line class="hx__plan-end-bracket" x1="${(x2 - tx * 5).toFixed(1)}" y1="${(y2 - ty * 5).toFixed(1)}" x2="${(x2 - tx * 9).toFixed(1)}" y2="${(y2 - ty * 9).toFixed(1)}"/>`);

      });

      openings.forEach((opening) => {
        const [x1, y1] = point(opening.from);
        const [x2, y2] = point(opening.to);
        const dx = x2 - x1, dy = y2 - y1;
        openingMarkup.push(
          `<line class="hx__plan-opening" x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}"/>`
        );
      });

      baseSegments.forEach((segment) => {
        const [x1, y1] = point(segment.from);
        const [x2, y2] = point(segment.to);
        const dx = x2 - x1, dy = y2 - y1;
        const magnitude = Math.max(Math.hypot(dx, dy), 1);
        const nx = -dy / magnitude, ny = dx / magnitude;
        const axisOffset = 28;
        const ax1 = x1 + nx * axisOffset, ay1 = y1 + ny * axisOffset;
        const ax2 = x2 + nx * axisOffset, ay2 = y2 + ny * axisOffset;
        const isVertical = Math.abs(dy) > Math.abs(dx);
        const labelX = (ax1 + ax2) / 2 + nx * (isVertical ? 78 : 0);
        const labelY = (ay1 + ay2) / 2 + ny * (isVertical ? 0 : 26);
        const parts = interruptionParts(segment.index);
        const detail = parts
          ? `${segment.modules} Elemente · ${segment.plannedLength.toFixed(2).replace('.', ',')} m`
          : `${segment.modules} ${segment.modules === 1 ? 'Element' : 'Elemente'} · ${segment.length.toFixed(2).replace('.', ',')} m`;
        const segmentHeights = heightsBySegment[segment.index] || [];
        const heightRuns = segmentHeights.filter((height, index) => index === 0 || height !== segmentHeights[index - 1]);
        const hasSegmentHeightChange = heightRuns.length > 1;
        const heightDetail = hasSegmentHeightChange ? (heightRuns.length <= 4 ? `Höhen: ${heightRuns.join(' / ')} cm` : `${heightRuns.length} Höhenabschnitte · ${[...new Set(heightRuns)].join('/')} cm`) : '';
        const labelWidth = hasSegmentHeightChange ? 190 : 112;
        const labelHeight = hasSegmentHeightChange ? 52 : 36;
        dimensionMarkup.push(
          `<line class="hx__plan-axis" x1="${ax1.toFixed(1)}" y1="${ay1.toFixed(1)}" x2="${ax2.toFixed(1)}" y2="${ay2.toFixed(1)}"/>`,
          `<line class="hx__plan-axis-tick" x1="${(ax1 - nx * 5).toFixed(1)}" y1="${(ay1 - ny * 5).toFixed(1)}" x2="${(ax1 + nx * 5).toFixed(1)}" y2="${(ay1 + ny * 5).toFixed(1)}"/>`,
          `<line class="hx__plan-axis-tick" x1="${(ax2 - nx * 5).toFixed(1)}" y1="${(ay2 - ny * 5).toFixed(1)}" x2="${(ax2 + nx * 5).toFixed(1)}" y2="${(ay2 + ny * 5).toFixed(1)}"/>`,
          `<rect class="hx__plan-axis-label-bg" x="${(labelX - labelWidth / 2).toFixed(1)}" y="${(labelY - labelHeight / 2).toFixed(1)}" width="${labelWidth}" height="${labelHeight}" rx="8"/>`,
          `<text class="hx__plan-axis-letter" x="${labelX.toFixed(1)}" y="${(labelY - (hasSegmentHeightChange ? 12 : 5)).toFixed(1)}" text-anchor="middle">${segment.label}</text>`,
          `<text class="hx__plan-axis-detail" x="${labelX.toFixed(1)}" y="${(labelY + (hasSegmentHeightChange ? 3 : 10)).toFixed(1)}" text-anchor="middle">${detail}</text>`,
          hasSegmentHeightChange ? `<text class="hx__plan-axis-height-detail" x="${labelX.toFixed(1)}" y="${(labelY + 18).toFixed(1)}" text-anchor="middle">${heightDetail}</text>` : ''
        );
      });

      const hasHeightChanges = heightsBySegment.some((heights) => new Set(heights).size > 1);
      const openingSummary = openings.length ? `<div class="hx__plan-openings-summary"><b>Unterbrechungen</b>${openings.map((opening) => `<span><strong>Strecke ${String.fromCharCode(65 + opening.segmentIndex)}</strong><em>${opening.width.toFixed(2).replace('.', ',')} m</em></span>`).join('')}</div>` : '';
      return `<div class="hx__plan-head"><div><span class="hx__plan-kicker">Live-Planung</span><b>${escapeHtml(shapes[state.shape].label)}${activeInterruptions().length ? ' mit Unterbrechung' : ''}${hasHeightChanges ? ' mit Höhenwechsel' : ''}</b><span>Jeder Heckenabschnitt automatisch im festen 1,30-m-Raster</span></div><small>${modules.reduce((sum, count) => sum + count, 0)} Rasterfelder</small></div>
        <svg class="hx__plan-drawing" viewBox="0 0 800 310" role="img" aria-label="Planungsskizze für ${escapeHtml(shapes[state.shape].label)} mit 1,30-Meter-Raster">
          <image class="hx__plan-logo" href="${escapeHtml(config.brand?.logoUrl || '')}" x="22" y="18" width="112" height="28" preserveAspectRatio="xMinYMid meet"/>
          <g>${moduleMarkup.join('')}</g><g>${openingMarkup.join('')}</g><g>${middleBracketMarkup.join('')}</g><g>${postMarkup.join('')}</g><g>${endBracketMarkup.join('')}</g><g>${heightChangeMarkup.join('')}</g><g>${dimensionMarkup.join('')}</g>
        </svg>${openingSummary}
        <div class="hx__plan-formula"><strong>1 Rasterfeld =</strong><span>1,20 m Heckenelement</span><b>+</b><span>Pfosten und Bügel</span><b>=</b><strong>1,30 m Gesamtmaß</strong></div>
        <div class="hx__plan-legend"><span><i class="is-hedge"></i>Heckenelement 1,20 m</span><span><i class="is-post"></i>Pfosten / Eckpunkt</span><span><i class="is-end-bracket"></i>Endpfahlbügel · einseitig</span><span><i class="is-middle-bracket"></i>Zwischenpfahlbügel · beidseitig</span>${hasHeightChanges ? '<span><i class="is-height-change"></i>Höhenwechsel</span>' : ''}</div>`;
    }

    function frontViewMarkup() {
      const modules = segmentModules();
      const heightsBySegment = segmentHeightPlan();
      const frontImage = escapeHtml(config.frontViewIvyUrl || '');
      const frontGreenImage = escapeHtml(config.frontViewIvyGreenUrl || config.frontViewIvyUrl || '');
      const frontRootsImage = escapeHtml(config.frontViewIvyRootsUrl || config.frontViewIvyUrl || '');
      const bracketPositions = (height) => {
        const levels = Number(config.levels?.[height]) || 1;
        return levels === 1 ? [52] : levels === 2 ? [12, 56] : [10, 45, 80];
      };
      const sideBracketPositions = (height, neighbourHeight, isEnd) => {
        const own = bracketPositions(height);
        if (isEnd || !neighbourHeight || Number(neighbourHeight) === Number(height)) return own;
        if (Number(height) > Number(neighbourHeight)) return own;
        const high = bracketPositions(neighbourHeight);
        const sharedHigh = high.slice(Math.max(0, high.length - own.length));
        return sharedHigh.map((position) => {
          const distanceFromBottom = Number(neighbourHeight) * (1 - position / 100);
          return Math.max(4, Math.min(96, 100 - distanceFromBottom / Number(height) * 100));
        });
      };
      const segmentMarkup = modules.map((count, segmentIndex) => {
        const label = String.fromCharCode(65 + segmentIndex);
        const heights = heightsBySegment[segmentIndex] || Array(count).fill(state.height);
        const parts = interruptionParts(segmentIndex);
        const plannedLength = parts?.planned || state.lengths[segmentIndex];
        const insertAfter = parts ? Math.min(count, Math.max(1, parts.leftModules)) : -1;
        const segmentFrontHeight = Math.round(Math.max(...heights.slice(0, count).map(Number)) * 1.4 + 28);
        const pieces = [];
        heights.slice(0, count).forEach((height, elementIndex) => {
          const afterGap = parts && elementIndex === insertAfter;
          const beforeGap = parts && elementIndex + 1 === insertAfter;
          const leftEnd = elementIndex === 0 || afterGap;
          const rightEnd = elementIndex === count - 1 || beforeGap;
          const leftNeighbour = leftEnd ? null : heights[elementIndex - 1];
          const rightNeighbour = rightEnd ? null : heights[elementIndex + 1];
          const bracketTop = (position) => Math.round(Number(height) * 1.4 * position / 100);
          const leftBrackets = sideBracketPositions(height, leftNeighbour, leftEnd).map((position) => `<b class="hx__front-bracket hx__front-bracket--left ${leftEnd ? 'hx__front-bracket--end' : 'hx__front-bracket--middle'}" style="top:${bracketTop(position)}px"></b>`).join('');
          const rightBrackets = sideBracketPositions(height, rightNeighbour, rightEnd).map((position) => `<b class="hx__front-bracket hx__front-bracket--right ${rightEnd ? 'hx__front-bracket--end' : 'hx__front-bracket--middle'}" style="top:${bracketTop(position)}px"></b>`).join('');
          const brackets = leftBrackets + rightBrackets;
          const startsHeightRun = elementIndex === 0 || heights[elementIndex - 1] !== height || afterGap;
          const greenHeight = Math.round(Number(height) * 1.4);
          const rightPostHeight = rightEnd || !rightNeighbour ? Number(height) : Math.max(Number(height), Number(rightNeighbour));
          const rightPostTop = -Math.round((rightPostHeight - Number(height)) * 1.4);
          pieces.push(`<div class="hx__front-element hx__front-element--${height}${leftEnd ? ' has-left-end' : ''}" style="--hx-front-green-height:${greenHeight}px;--hx-front-height:${greenHeight + 28}px">${startsHeightRun ? `<span>Begrünung<br><em>${height} cm</em></span>` : ''}<div class="hx__front-green"><img src="${frontGreenImage}" alt="Efeu-Begrünung mit ${height} cm Höhe" loading="lazy"></div><div class="hx__front-roots"><img src="${frontRootsImage}" alt="" aria-hidden="true" loading="lazy"></div>${leftEnd ? '<i class="hx__front-post hx__front-post--left"></i>' : ''}<i class="hx__front-post hx__front-post--right" style="--hx-front-post-top:${rightPostTop}px"></i>${brackets}</div>`);
          if (parts && elementIndex + 1 === insertAfter) {
            const gapWidth = Math.max(70, Math.round(parts.width * 140));
            pieces.push(`<div class="hx__front-gap${parts.width < 1.3 ? ' is-narrow' : ''}" style="--hx-front-gap:${gapWidth}px;--hx-front-gap-height:${segmentFrontHeight}px"><span>Unterbrechung</span><strong>${parts.width.toFixed(2).replace('.', ',')} m</strong></div>`);
          }
        });
        const technicalInfo = `<aside class="hx__front-measures" aria-label="Technische Maße"><div class="hx__front-measure hx__front-measure--root"><i></i><span>Wurzelballen<br><strong>ca. 20 cm</strong></span></div><div class="hx__front-measure hx__front-measure--foundation"><i></i><span>Punktfundament<br><strong>40–60 cm</strong></span></div></aside>`;
        return `<section class="hx__front-segment"><header><strong>Strecke ${label}</strong><span>${count} ${count === 1 ? 'Element' : 'Elemente'} · ${plannedLength.toFixed(2).replace('.', ',')} m</span></header><div class="hx__front-track">${pieces.join('')}${technicalInfo}</div></section>`;
      }).join('');
      const legend = `<div class="hx__front-legend"><span><i class="is-hedge"></i>Heckenelement / Begrünung</span><span><i class="is-post"></i>Pfosten</span><span><i class="is-bracket"></i>Befestigungsbügel</span><span><i class="is-ground"></i>Bodenlinie</span><span><i class="is-root"></i>Wurzelballen · ca. 20 cm</span><span><i class="is-foundation"></i>Punktfundament · 40–60 cm</span></div>`;
      return `<div class="hx__front-view"><div class="hx__front-intro"><div><strong>Vorderansicht</strong><span>Schematische Darstellung mit Efeubegrünung</span></div><small>Elementbreite 1,20 m · Begrünungshöhen maßstäblich</small></div>${segmentMarkup}${legend}</div>`;
    }

    function renderPlanner() {
      syncAssignments();
      const calculation = calculate();
      const dateLabel = new Intl.DateTimeFormat('de-DE').format(new Date());
      const heightSummary = requiredHeights().map((height) => `${height} cm`).join(' / ');
      const lengthFacts = state.lengths.slice(0, shapes[state.shape].segments).map((value, index) => {
        const parts = interruptionParts(index);
        return `<div><span>Maß ${String.fromCharCode(65 + index)}${parts ? ` · Eingabe ${value.toFixed(2).replace('.', ',')} m` : ''}</span><strong>${(parts?.planned || value).toFixed(2).replace('.', ',')} m</strong></div>`;
      }).join('');
      const printHeader = `<header class="hx__print-document-head"><div><img src="${escapeHtml(config.brand?.logoUrl || '')}" alt="HELIX Pflanzen"><h2>Planungsunterlage - 'Hecke am laufenden Meter'</h2><p>Ihre individuelle Heckenplanung</p></div><dl><dt>Planungsstand</dt><dd>${dateLabel}</dd></dl></header>
        <div class="hx__print-facts"><div><span>Form</span><strong>${escapeHtml(shapes[state.shape].label)}${activeInterruptions().length ? ' mit Unterbrechung' : ''}</strong></div><div><span>Höhe</span><strong>${heightSummary}</strong></div>${lengthFacts}</div>`;
      const hedgeRows = calculation?.rows?.filter((row) => row.type === 'hedge') || [];
      const mixSummary = hedgeRows.length
        ? `<div class="hx__mix-summary"><b>Ihre Zusammenstellung</b><div>${hedgeRows.map((row) => `<span><strong>${row.qty} ×</strong> ${escapeHtml(productLabel(row.key))} <em>· ${row.height} cm</em></span>`).join('')}</div><small>Die Gesamtzahl bleibt automatisch erhalten.</small></div>`
        : '';
      const printMaterialRows = calculation ? [
        '<tr class="hx__print-group"><th colspan="2">Heckenelemente</th></tr>',
        ...calculation.rows.filter((row) => row.type === 'hedge').map((row) => `<tr><td><strong>${escapeHtml(row.name)}</strong>${row.detail ? `<span>${escapeHtml(row.detail)}</span>` : ''}</td><td>${row.qty}</td></tr>`),
        '<tr class="hx__print-group"><th colspan="2">Montagematerial</th></tr>',
        ...calculation.rows.filter((row) => row.type !== 'hedge').map((row) => `<tr><td><strong>${escapeHtml(row.name)}</strong>${row.detail ? `<span>${escapeHtml(row.detail)}</span>` : ''}</td><td>${row.qty}</td></tr>`)
      ].join('') : '';
      const printDetails = `<div class="hx__plan-print-details">
        <h3>Materialübersicht</h3>
        ${calculation ? `<table><colgroup><col class="hx__print-col-material"><col class="hx__print-col-qty"></colgroup><thead><tr><th>Material</th><th>Anzahl</th></tr></thead><tbody>${printMaterialRows}</tbody></table>` : '<p>Die Materialübersicht wird ergänzt, sobald eine Heckensorte ausgewählt wurde.</p>'}
        <div class="hx__print-notes"><strong>Planungshinweise</strong>${activeInterruptions().map(({ interruption, index }) => `<span>Unterbrechung in Strecke ${String.fromCharCode(65 + index)}: ${interruption.width.toFixed(2).replace('.', ',')} m breit, Abstand vom Streckenanfang ${interruption.position.toFixed(2).replace('.', ',')} m.</span>`).join('')}${requiredHeights().length > 1 ? `<span>Höhenfolge: ${escapeHtml(heightPlanSummary())}.</span>` : ''}<span>Grenzabstände und örtliche Vorgaben bitte vor dem Einbau prüfen.</span></div>
      </div>`;
      const printFooter = `<footer class="hx__plan-print-footer"><img src="${escapeHtml(config.brand?.logoUrl || '')}" alt="HELIX Pflanzen"><address><strong>${escapeHtml(config.brand?.company || 'Helix Pflanzen GmbH')}</strong><span>${escapeHtml(config.brand?.address || '')}</span><span>${escapeHtml(config.brand?.email || '')} · Tel. ${escapeHtml(config.brand?.phone || '')}</span><span>${escapeHtml(config.brand?.website || '')}</span></address></footer>`;
      const actions = `<div class="hx__plan-actions"><button type="button" data-print-plan>Skizze drucken</button><small>Für eine saubere Ein-Seiten-Ausgabe im Druckdialog „Kopf- und Fußzeilen“ deaktivieren. Dort kann die Planungsunterlage auch als PDF gespeichert werden.</small></div>`;
      qa('[data-plan]').forEach((host) => {
        const viewSwitch = `<div class="hx__plan-view-switch" role="group" aria-label="Darstellung wählen"><button type="button" class="is-active" data-plan-view="drawing" aria-pressed="true">Planungsskizze</button><button type="button" data-plan-view="front" aria-pressed="false">Vorderansicht</button></div>`;
        host.innerHTML = `${printHeader}${viewSwitch}<div class="hx__plan-view hx__plan-view--drawing" data-plan-view-panel="drawing">${planSvg()}</div><div class="hx__plan-view hx__plan-view--front" data-plan-view-panel="front" hidden>${frontViewMarkup()}</div>${mixSummary}${printDetails}${printFooter}${actions}`;
        host.querySelectorAll('[data-plan-view]').forEach((button) => button.addEventListener('click', () => {
          const selected = button.dataset.planView;
          host.querySelectorAll('[data-plan-view]').forEach((item) => {
            const active = item.dataset.planView === selected;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          host.querySelectorAll('[data-plan-view-panel]').forEach((panel) => { panel.hidden = panel.dataset.planViewPanel !== selected; });
        }));
        host.querySelector('[data-print-plan]')?.addEventListener('click', () => printPlan(host, false));
      });
    }

    function printPlan(host, pdfHint) {
      qa('[data-plan]').forEach((plan) => plan.classList.remove('is-print-target'));
      document.querySelector('.hx-print-sheet')?.remove();
      const printSheet = document.createElement('div');
      printSheet.className = 'hx-print-sheet';
      const printPlanClone = host.cloneNode(true);
      printPlanClone.classList.add('is-print-target');
      printPlanClone.removeAttribute('data-plan');
      printSheet.appendChild(printPlanClone);
      document.body.appendChild(printSheet);
      root.classList.add('hx--printing');
      document.body.classList.add('hx-print-mode');
      const cleanup = () => {
        printSheet.remove();
        root.classList.remove('hx--printing');
        document.body.classList.remove('hx-print-mode');
      };
      window.addEventListener('afterprint', cleanup, { once: true });
      if (pdfHint) toast('Bitte im folgenden Druckdialog „Als PDF speichern“ als Ziel auswählen.', 6500);
      window.setTimeout(() => {
        try { window.print(); }
        catch (error) { cleanup(); throw error; }
      }, 80);
    }

    function renderResult() {
      const calculation = calculate();
      const resultVisual = (row) => {
        if (row.image) return `<span class="hx__result-visual"><img src="${escapeHtml(row.image)}" alt="" loading="lazy"></span>`;
        if (row.kind === 'end') return '<span class="hx__result-visual hx__result-symbol" aria-hidden="true"><svg viewBox="0 0 48 56"><circle cx="24" cy="27" r="9"/><path d="M33 27h10"/></svg></span>';
        if (row.kind === 'middle') return '<span class="hx__result-visual hx__result-symbol" aria-hidden="true"><svg viewBox="0 0 48 56"><circle cx="24" cy="27" r="9"/><path d="M15 27H4M33 27h11"/></svg></span>';
        return '';
      };
      q('[data-result]').innerHTML = calculation ? `<table><thead><tr><th>Artikel</th><th>Anzahl</th><th>Gesamtpreis</th></tr></thead><tbody>${calculation.rows.map((row) => `<tr><td><div class="hx__result-article">${resultVisual(row)}<span><span class="hx__result-name">${escapeHtml(row.name)}</span>${row.detail ? `<small class="hx__result-detail">${escapeHtml(row.detail)}</small>` : ''}</span></div></td><td>${row.qty}</td><td>${currency.format(row.qty * row.price)}</td></tr>`).join('')}</tbody><tfoot><tr><th colspan="2">Gesamt</th><th>${currency.format(calculation.total)}</th></tr></tfoot></table>` : '<p>Bitte zuerst mindestens ein Heckensortiment auswählen.</p>';
    }

    function renderSummary() {
      const calculation = calculate();
      q('[data-summary-height]').textContent = requiredHeights().map((height) => `${height} cm`).join(' / ');
      q('[data-summary-shape]').textContent = `${shapes[state.shape].label}${activeInterruptions().length ? ' mit Unterbrechung' : ''}`;
      q('[data-summary-product]').textContent = state.selectedProducts.length > 1 ? `${state.selectedProducts.length} Sorten kombiniert` : state.selectedProducts.length === 1 ? productLabel(state.selectedProducts[0]) : 'Noch nicht ausgewählt';
      q('[data-summary-elements]').textContent = calculation ? calculation.modules : '–';
      q('[data-summary-posts]').textContent = calculation ? calculation.posts : '–';
      q('[data-summary-brackets]').textContent = calculation ? calculation.brackets : '–';
      q('[data-total]').textContent = calculation ? currency.format(calculation.total) : '–';
      qa('[data-cart]').forEach((button) => { button.disabled = !calculation; });
    }

    function renderAll() {
      qa('[data-height]').forEach((button) => {
        const cardHeight = Number(button.dataset.height);
        const selected = cardHeight === state.height;
        const heightAvailable = Object.values(catalog).some((product) => {
          const variant = product.variants[cardHeight];
          return Boolean(variant && variant.available !== false);
        });
        button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
        button.disabled = !heightAvailable;
        button.classList.toggle('is-unavailable', !heightAvailable);
        const choice = button.querySelector('.hx__choose'); if (choice) choice.textContent = selected ? 'Ausgewählt' : 'Auswählen';
        const assortment = button.querySelector('.hx__height-assortment');
        if (assortment) {
          const familyNames = { evergreen: 'Immergrüne Hecken', flowering: 'Blühende Hecken', enjoyment: 'Genuss-Hecken' };
          const assortmentOrder = {
            evergreen: ['Efeu', 'Kaukasischer Efeu', 'Spindelstrauch', 'Geißblatt'],
            flowering: ['Color', 'Clematis', 'Kletterhortensie'],
            enjoyment: ['Kiwi', 'Spaltkörbchen']
          };
          const grouped = Object.entries(catalog).reduce((result, [key, product]) => {
            const variant = product.variants[cardHeight];
            if (!variant || variant.available === false) return result;
            const family = product.family || 'evergreen';
            const label = shortProductLabel(key, product);
            (result[family] ||= new Set()).add(label);
            return result;
          }, {});
          assortment.innerHTML = ['evergreen', 'flowering', 'enjoyment'].filter((family) => grouped[family]?.size).map((family) => {
            const labels = [...grouped[family]].sort((a, b) => {
              const order = assortmentOrder[family] || [];
              const aIndex = order.indexOf(a), bIndex = order.indexOf(b);
              return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
            });
            return `<span class="hx__height-group"><span>${familyNames[family]}</span><em>${labels.map(escapeHtml).join(' · ')}</em></span>`;
          }).join('');
        }
      });
      qa('[data-shape]').forEach((button) => {
        const selected = button.dataset.shape === state.shape;
        button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
      });
      const advancedMode = q('[data-advanced-mode]');
      if (advancedMode) advancedMode.checked = state.interruptionMode;
      const advancedDetails = q('[data-advanced-details]');
      if (advancedDetails && state.interruptionMode) advancedDetails.open = true;
      renderProducts(); renderMeasures(); renderPlanner(); renderResult(); renderSummary(); saveState();
    }

    let cartBusy = false;

    async function refreshCartUi() {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Warenkorbstatus konnte nicht geladen werden.');
      const cart = await cartResponse.json();
      const count = Number(cart.item_count) || 0;
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach((element) => {
        element.textContent = String(count);
      });
      document.querySelectorAll('.cart-count-bubble').forEach((element) => {
        element.classList.toggle('hidden', count === 0);
        element.removeAttribute('hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart } }));
      return cart;
    }

    async function addToCart() {
      const calculation = calculate();
      if (!calculation || cartBusy) return;
      cartBusy = true;
      state.step = 5;
      saveState();
      const buttons = qa('[data-cart]');
      const originalLabels = buttons.map((button) => button.textContent);
      buttons.forEach((button) => { button.disabled = true; button.classList.add('is-loading'); button.textContent = 'Wird hinzugefügt …'; });
      try {
        const endpoint = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const assignmentHeights = moduleHeights();
        const mixPlan = state.assignments.map((key, index) => `${index + 1}:${productLabel(key)} (${assignmentHeights[index] || state.height} cm)`).join(' | ');
        const distinctHedges = new Set(state.assignments.filter(Boolean));
        const configurationUrl = `${window.location.pathname}${window.location.search}#HelixConfigurator-${config.sectionId}`;
        const heightPlan = requiredHeights().length > 1 ? heightPlanSummary() : '';
        const items = calculation.rows.map((row) => ({
          id: row.id,
          quantity: row.qty,
          properties: {
            Konfiguration: `${requiredHeights().map((height) => `${height} cm`).join(' / ')} · ${shapes[state.shape].label}${activeInterruptions().length ? ' mit Unterbrechung' : ''}`,
            Maße: state.lengths.slice(0, shapes[state.shape].segments).map((value, index) => `${String.fromCharCode(65 + index)} ${value.toFixed(2).replace('.', ',')} m`).join(' · '),
            ...(activeInterruptions().length ? { Unterbrechungen: activeInterruptions().map(({ interruption, index }) => `Strecke ${String.fromCharCode(65 + index)} · Breite ${interruption.width.toFixed(2).replace('.', ',')} m · Abstand ${interruption.position.toFixed(2).replace('.', ',')} m`).join(' | ') } : {}),
            ...(heightPlan ? { Höhenwechsel: heightPlan } : {}),
            ...(row.type === 'hedge' && distinctHedges.size > 1 ? { 'Mischhecken-Plan': mixPlan } : {}),
            '_Helix-Konfigurator-URL': configurationUrl
          }
        }));
        const response = await fetch(endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const rawError = await response.text();
          let reason = '';
          try {
            const detail = JSON.parse(rawError);
            reason = detail.description || detail.message || '';
          } catch (parseError) { reason = rawError; }
          throw new Error(reason || `Shopify-Fehler ${response.status}`);
        }
        await refreshCartUi();
        buttons.forEach((button) => { button.textContent = 'Im Warenkorb ✓'; });
        toast('Ihre Konfiguration wurde vollständig in den Warenkorb gelegt.');
        if (config.cartRedirect) window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      } catch (error) {
        console.error(error);
        toast(`Nicht alle Artikel konnten hinzugefügt werden. Bitte Verfügbarkeit und Variant-IDs prüfen. ${error.message || ''}`, 9000);
      } finally {
        window.setTimeout(() => {
          buttons.forEach((button, index) => { button.disabled = !calculate(); button.classList.remove('is-loading'); button.textContent = originalLabels[index]; });
          cartBusy = false;
        }, 1800);
      }
    }

    function toast(message, duration = 3800) {
      const element = q('[data-toast]'); element.textContent = message; element.classList.add('is-visible');
      window.setTimeout(() => element.classList.remove('is-visible'), duration);
    }

    qa('[data-height]').forEach((button) => button.addEventListener('click', () => { if (button.disabled) return; state.height = Number(button.dataset.height); ensureSelections(); syncAssignments(); renderAll(); }));
    qa('[data-shape]').forEach((button) => button.addEventListener('click', () => {
      if (state.shape !== button.dataset.shape) {
        state.interruptions.forEach((interruption, index) => {
          if (interruption.enabled) state.lengths[index] = snapLength(state.lengths[index]);
          interruption.enabled = false;
        });
        state.heightChanges.forEach((change) => { change.enabled = false; });
        state.customHeightMode = false;
      }
      state.shape = button.dataset.shape;
      syncAssignments(); renderAll();
    }));
    q('[data-advanced-mode]')?.addEventListener('change', (event) => {
      if (!event.target.checked) {
        state.interruptions.forEach((interruption, index) => {
          if (interruption.enabled) state.lengths[index] = snapLength(state.lengths[index]);
          interruption.enabled = false;
        });
        state.heightChanges.forEach((change) => { change.enabled = false; });
        state.customHeightMode = false;
      }
      state.interruptionMode = event.target.checked;
      normalizeInterruptions(); syncAssignments(); renderAll();
    });
    qa('[data-next]').forEach((button) => button.addEventListener('click', () => {
      const next = Number(button.dataset.next);
      if (next >= 5 && !calculate()) { toast('Bitte für jede eingeplante Höhe eine verfügbare Heckensorte auswählen.'); showStep(4); return; }
      showStep(next);
    }));
    qa('[data-back]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.back))));
    qa('[data-step-link]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.stepLink))));
    qa('[data-cart]').forEach((button) => button.addEventListener('click', addToCart));

    if (!validProducts().length) {
      state.height = [100, 180, 205].find((height) => Object.values(catalog).some((product) => {
        const variant = product.variants[height];
        return Boolean(variant && variant.available !== false);
      })) || state.height;
    }
    if (!state.customHeightMode && state.heightChanges.some((change) => change.enabled)) {
      state.customHeightPlans = segmentHeightPlan().map((plan) => [...plan]);
      state.customHeightMode = true;
      state.heightChanges.forEach((change) => { change.enabled = false; });
    }
    renderAll();
    showStep(state.step, false);
  });
})();
